export default {
      id: "oc-integral-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-integral",
      toString: function () {
        return this.url;
      }
    }